export const ContentStatus = {
  AVAILABLE: 'available',
  BLOCKED: 'blocked',
  ACTIVE: 'active',
};